import React, { useEffect, useRef, useState } from 'react';
import { Badge, Card, CardBody, Col, Container, Modal, ModalHeader, Row, Tooltip } from 'reactstrap';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { IPostOrdersModel } from 'models/PostOrders.Model';
import moment from 'moment';
import CommonService from 'services/CommonService';
import { IDashboardStats } from 'models/DashboardStats.Model';
import { HelperConstant } from '../../helpers/HelperConstant';
import { GetHome, GetLocation, ID_EncryptionKey, aes_encryption, currencyByCountry, getCountryCodeStorage, getLocalStorage, getStatusIds, getStatusName, isMobile, isTablet, isValidUserAuthenticateForSeo, loadConfigforImageApiUrl } from '../../helpers/Helper';
import { CustomButton } from 'components/shared/CustomButton';
import { useTypedDispatch, useTypedSelector } from 'features/reduxhooks/ReduxHooks';
import { getDecodedAccessToken, getPersonId } from '../../helpers/TokenHelper';
import { FilterDataId, routerPage } from 'features/reducers/filterdata/FilterData.Reducers';
import Paginate from 'components/Common/Paginate';
import emptyBox from '../../assets/images/dashboard/empty-box.png'
import { IGetOrdersByRiderModel } from 'models/GetOrdersByRider.Model';
import FileSaver from 'file-saver';
import AssigneeModal from 'components/assignemodal/AssigneeModal';
import CustomLoader from 'components/Common/CustomLoader';
import { Directory, Filesystem, WriteFileResult } from "@capacitor/filesystem";
import { Capacitor } from '@capacitor/core';
import { CustomToaster } from 'components/shared/CustomToaster';
import EnquiryServices from 'services/Enquiry.Services';
import { FileOpener, FileOpenerOptions } from '@capacitor-community/file-opener';
import { ActionPerformed, LocalNotifications, RegisterActionTypesOptions, ScheduleOptions } from "@capacitor/local-notifications";
import Filter from 'components/filter/Filter';
import UseDebounce from 'components/shared/UseDebounce';
import { updateDashboardFilter } from 'features/reducers/filterdata/DashboardFilter.Reducers';

var CryptoJS = require("crypto-js");

type UTMModel = { ThemeColor: string, Name: string, UTM_Id: string }

type Param = {
  routeId: any
}

const Dashboard = () => {

  document.title = "Dashboard";
  let navigate = useNavigate();
  const { routeId } = useParams<Param>();
  const dispatch = useTypedDispatch();
  const [OrderId, setOrderId] = useState();
  let priorDate = new Date(new Date().setDate(new Date().getDate() - 30));
  const [toast, setToast] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [copiedItems, setCopiedItems] = useState({});


  const [rowsPerPage] = useState<number>(50);
  const [currentPage, setCurrentPage] = useState<any>(1);
  const [offsetStart, setOffsetStart] = useState<number>(0);

  const [showToast1, setShowToast1] = useState(false);
  const [GetAllOrdersData, setGetAllOrdersData] = useState<any>([]);
  const [AssigneeList, setAssigneeList] = useState<Array<any>>([]);
  const [TechnicianAssignId, setTechnicianAssignId] = useState<number>(0);
  const [DashboardStats, setDashboardStats] = useState<IDashboardStats>();
  const [DashboardName, setDashboardName] = useState<any>(HelperConstant.dashboardNameIndex.AllOrders);
  const [FilterData, setFilterData] = useState([]);
  const [MenuName, setMenuName] = useState<any>("All Orders");
  const [showModal, setShowModal] = useState(false);
  const [recordsCount, setRecordsCount] = useState<number>(0);
  const [isToday] = useState(true);
  const [modal_center, setmodal_center] = useState(false);
  const [filerModal, setFilterModal] = useState(false);
  const [searchValue, setSearchValue] = useState('');
  const [showLoading, setShowLoading] = useState(false);
  const [ttop, setttop] = useState<boolean>(false);
  const debouncedSearch = UseDebounce(searchValue, 1000);
  const [cdnUrl, setCdnUrl] = useState("");
  const [utmLinks, setUtmLinks] = useState<Array<UTMModel>>([]);
  const [isButton, setisButton] = useState<boolean>(false);
  const [isAssignBtnClicked, setIsAssignBtnClicked] = useState<boolean>(false);
  const [maxExcelExportDays, setMaxExcelExportDays] = useState<number>()
  const segmentValue = localStorage.getItem("routeFrom") as any;

  let productName = useTypedSelector(state => state.DashboardFilterReducers[segmentValue][routeId].productName);
  let brandName = useTypedSelector(state => state.DashboardFilterReducers[segmentValue][routeId].BrandName);
  let modelName = useTypedSelector(state => state.DashboardFilterReducers[segmentValue][routeId].ModalName);
  let cityName = useTypedSelector(state => state.DashboardFilterReducers[segmentValue][routeId].CityName);
  let RiderName = useTypedSelector(state => state.DashboardFilterReducers[segmentValue][routeId].RiderName);
  let AliasName = useTypedSelector(state => state.DashboardFilterReducers[segmentValue][routeId].AliasName);
  let promoCodeName = useTypedSelector(state => state.DashboardFilterReducers[segmentValue][routeId].PromoCodeName);
  let productId = useTypedSelector(state => state.DashboardFilterReducers[segmentValue][routeId].productId);
  let brandId = useTypedSelector(state => state.DashboardFilterReducers[segmentValue][routeId].BrandId);
  let modelId = useTypedSelector(state => state.DashboardFilterReducers[segmentValue][routeId].ModelId);
  let cityId = useTypedSelector(state => state.DashboardFilterReducers[segmentValue][routeId].CityId);
  let riderId = useTypedSelector(state => state.DashboardFilterReducers[segmentValue][routeId].RiderId);
  let PromoCode = useTypedSelector(state => state.DashboardFilterReducers[segmentValue][routeId].PromoCode);
  let FromDate = useTypedSelector(state => state.DashboardFilterReducers[segmentValue][routeId].FromDate);
  let ToDate = useTypedSelector(state => state.DashboardFilterReducers[segmentValue][routeId].ToDate);

  const PersonId = getDecodedAccessToken(getLocalStorage().Token)?.PersonId;
  const isAllCondtion = parseInt(routeId) === HelperConstant.dashboardNameIndex.AllOrders
  const isAppointmentDateCondtion = (parseInt(routeId) === HelperConstant.dashboardNameIndex.OpenOrders || parseInt(routeId) === HelperConstant.dashboardNameIndex.InProgressOrders)
  const isCompletedDateCondition = (parseInt(routeId) === HelperConstant.dashboardNameIndex.CancelledOrders || parseInt(routeId) === HelperConstant.dashboardNameIndex.FailedOrders || parseInt(routeId) === HelperConstant.dashboardNameIndex.ReturnOrders || parseInt(routeId) === HelperConstant.dashboardNameIndex.CompletedOrders || parseInt(routeId) === HelperConstant.dashboardNameIndex.CancelRequestOrders)

  const pendingStatusIds = `${HelperConstant.StatusId.PENDING},${HelperConstant.StatusId.PUBLICRECALCULATION},${HelperConstant.StatusId.ADMINCRECALCULATION}`;
  const dateDiff = moment(ToDate).diff(moment(FromDate), 'days');
  const isExportDisabled = GetAllOrdersData.length === 0 ||ToDate == null || FromDate == null|| (maxExcelExportDays !== undefined && dateDiff > maxExcelExportDays);
  const tooltipMessage = isExportDisabled  ? `Only ${maxExcelExportDays} days records can be downloaded` : 'Download Orders List';

  let dashboardFiltersDataFromLocal = localStorage.getItem("DashboardFilter");
  let routeFrom = localStorage.getItem("routeFrom");
  function removeBodyCss() {
    document.body.classList.add("no_padding");
  }

  function filterOpen() {
    setFilterModal(!filerModal)
    removeBodyCss();
  }
  const handleSearchChange = (e) => {
    let value = e.target.value;
    setSearchValue(value);

    // if (value.length >= 3) {
    //   setSearchText(e.target.value);
    //   dispatch(FilterDataId({ payload: 0, type: "OffsetStart" }));
    // }

  };

  const getOrderSummary = (id: any, IsCategoryChanged) => {
    const eOrderId = aes_encryption(id);
    if (IsCategoryChanged == true) {
      const newTabUrl = `/re-quote/${eOrderId}?dashboardStatusId=${routeId}`;
      window.open(newTabUrl);
    }
    else {
      const newTabUrl = `/agent-ticket-view/${eOrderId}?dashboardStatusId=${routeId}`;
      window.open(newTabUrl);
    }
  }

  const getStatsName = (dashboardName?: number) => {
    dashboardName = dashboardName ? dashboardName : DashboardName;
    setMenuName(getStatusName(dashboardName));
  }

  const getOrders = (statsId: number, fromDate: any, toDate: any, assign?: "assign") => {
    setDashboardName(statsId);
    getStatsName(statsId);
    const status = getStatusIds(statsId);


    if (getStatusIds(statsId) == pendingStatusIds) {
      GetEnquiryList(productId, statsId, status, searchValue, modelId, brandId, cityId, riderId, PromoCode, PersonId, fromDate, toDate, null, null, HelperConstant.serviceTypeId.SELL, offsetStart, rowsPerPage, assign)
    } else {
      postOrderList(productId, statsId, status, searchValue, modelId, brandId, cityId, riderId, PromoCode, PersonId, fromDate, toDate, null, null, HelperConstant.serviceTypeId.SELL, offsetStart, rowsPerPage, assign);
    }
  }

  const GetDashboardStats = (isToday) => {
    CommonService.getWithQueryParam("sell", "GetDashboardStats", "isToday", isToday).then(res => {
      if (res.status === 200) {
        setDashboardStats(res.data);
      }
    }).catch(e => {
      console.log(e);
    });
  }

  const TechnicianAssigneeData = (id) => {
    setIsAssignBtnClicked(true);
    setShowLoading(true);
    var person = getPersonId() as any;
    var personId = 0;

    CommonService.postWithTripleEntity("sell", "AssignProcess", OrderId, id, person).then(res => {
      if (res.status === 200) {
        setShowToast1(true);
        setShowModal(false);
        // GetDashboardStats(isToday);
        setmodal_center(false);
        setIsAssignBtnClicked(false);
        setTimeout(() => {
          getOrders(HelperConstant.dashboardNameIndex.OpenOrders, FromDate, ToDate, "assign");
          setShowLoading(false);
        }, 2000);
      }
    })
    setisButton(true);
  }
  const postOrderList = (productTypeId: any, dashboardNameIndex?: any, statusId?: any, searchText?: any, seriesModelId?: any, brandMasterId?: any, cityId?: any, riderId?: any, PromoCode?: any, PersonId?: any, FromDate?: any, ToDate?: any, CompletedStartDate?: any, CompletedEndDate?: any, ServiceTypeId?: any, OffsetStart?: any, RowsPerPage?: any, assign?: "assign") => {
    setShowLoading(true)
    const request: IPostOrdersModel = {
      OffsetStart: OffsetStart,
      RowsPerPage: RowsPerPage,
      SortOrder: "DESC",
      SortOrderColumn: "Modified",
      SearchText: searchText == "" ? null : searchText,
      ProductTypeId: productTypeId,
      StatusId: statusId,
      seriesModelId: seriesModelId,
      brandMasterId: brandMasterId,
      cityId: cityId,
      riderId: riderId,
      ReferralCodeId: PromoCode > 0 ? PromoCode : null,
      FromDate: (FromDate && moment(FromDate).format('L')),
      ToDate: (ToDate && moment(ToDate).format('L')),
      CompletedStartDate: null,
      CompletedEndDate: null,
      PersonId: null,
      ServiceTypeId: ServiceTypeId,
    };
    CommonService.post("sell", "GetElasticOrderSearchResult", request).then(res => {
      if (res.status === 200) {
        setGetAllOrdersData(res.data.Items);
        setFilterData(res.data.Items);
        setRecordsCount(res.data.RecordsCount);
        if (assign === "assign") {
          // navigate(`/dashboard/${dashboardNameIndex}`);
          setisButton(false);
        }
        if (dashboardNameIndex) {
          setDashboardName(dashboardNameIndex);
          // getStatsName(dashboardNameIndex);
        }
        setShowLoading(false);
      }
    }).catch(e => {
      if (e == 'Request failed with status code 401') {
        console.error("API error:",e);
      navigate('/logout')
    } else {
      console.error("API error:",e.response);
    }
    setShowLoading(false);
    })
  }

  const GetEnquiryList = (productTypeId: any, dashboardNameIndex?: any, statusId?: any, searchText?: any, seriesModelId?: any, brandMasterId?: any, cityId?: any, riderId?: any, PromoCode?: any, PersonId?: any, FromDate?: any, ToDate?: any, CompletedStartDate?: any, CompletedEndDate?: any, ServiceTypeId?: any, OffsetStart?: any, RowsPerPage?: any, assign?: "assign") => {
    setShowLoading(true)
    const request: IPostOrdersModel = {
      OffsetStart: OffsetStart,
      RowsPerPage: RowsPerPage,
      SortOrder: "DESC",
      SortOrderColumn: "Modified",
      SearchText: searchText,
      ProductTypeId: productTypeId,
      StatusId: statusId,
      seriesModelId: seriesModelId,
      brandMasterId: brandMasterId,
      cityId: cityId,
      riderId: riderId,
      ReferralCodeId: PromoCode,
      FromDate: FromDate && moment(FromDate).format('L'),
      ToDate: ToDate && moment(ToDate).format('L'),
      CompletedStartDate: null,
      CompletedEndDate: null,
      PersonId: null,
      ServiceTypeId: ServiceTypeId,
    };
    EnquiryServices.GetEnquiryList(request).then(res => {
      if (res.status === 200) {
        setGetAllOrdersData(res.data.Items);
        setFilterData(res.data.Items);
        setRecordsCount(res.data.RecordsCount);
        if (dashboardNameIndex) {
          setDashboardName(dashboardNameIndex);
        }
        setShowLoading(false);
        let pendingOrders = (res.data.Items).filter(item => item?.StatusId === HelperConstant.StatusId.PENDING);
        localStorage.setItem("PendingOrders", JSON.stringify(pendingOrders));
      }
    }).catch(e => console.log(e))
  }


  const GetStatusBadge = (status: any) => {
    switch (status) {
      case 'Assigned':
        return "#34c38f";
      case 'Completed':
        return '#34c38f'
      case 'Scheduled':
        return '#556ee6'
      case 'Re-Scheduled':
        return '#50a5f1'
      case 'Re-Quote':
        return '#f1b44c'
      case 'Cancelled':
        return '#f46a6a'
      case 'Failed':
        return '#f46a6a'
      case 'Cancel Request':
        return '#f46a6a'
      case 'Pending':
        return '#556ee6'
      case 'Return':
        return '#f46a6a'
      case 'Scheduled By Telecaller':
        return '#74788D'
      default:
        return '#556ee6'
    }
  }

  const downloadMobileInvoice = async (file: any, path: any) => {
    Filesystem.writeFile({
      path: path,
      data: file,
      directory: Directory.Documents,
      recursive: true
    }).then((res: WriteFileResult) => {
      showInvoiceNotification(res.uri, path);
    }).catch(e => console.log(e));
  };

  const openDownloadedFile = async (uri: any) => {
    try {
      const fileOpenerOptions: FileOpenerOptions = {
        filePath: uri,
        openWithDefault: true,
      };
      await FileOpener.open(fileOpenerOptions);

    } catch (e) {
      console.log('Error opening file', e);
    }
  };

  const showInvoiceNotification = async (uri: any, name: any) => {
    let options: ScheduleOptions = {
      notifications: [
        {
          id: 1,
          title: name,
          body: "Download completed. File saved in Documents",
          extra: { uri: uri },
          actionTypeId: "open_pdf"
        }
      ]
    };

    try {
      await LocalNotifications.schedule(options);
    } catch (error) {
      console.log(error);
    }

    LocalNotifications.addListener('localNotificationActionPerformed', async (notification) => {
      if (notification.notification.actionTypeId === 'open_pdf') {
        const uri = notification.notification.extra.uri;
        openDownloadedFile(uri);
      }
    });
  }

  const downloadInvoice = () => {
    setShowLoading(true)
    let data = {
      SortOrder: "DESC",
      SortOrderColumn: "Modified",
      RiderId: riderId,
      ProductTypeId: productId ? productId : undefined,
      BrandMasterId: brandId ? brandId : undefined,
      SeriesModelId: modelId ? modelId : undefined,
      CityId: cityId ? cityId : undefined,
      ReferralCodeId: PromoCode ? PromoCode : undefined,
      FromDate: FromDate ? moment(FromDate).format('L') : null,
      ToDate: ToDate ? moment(ToDate).format('L') : null,
      CompletedStartDate: null,
      CompletedEndDate: null,
      PersonId: null,
      StatusId: getStatusIds(parseInt(routeId)),
      ServiceTypeId: HelperConstant.serviceTypeId.SELL,
      RowsPerPage: recordsCount
    } as IGetOrdersByRiderModel;

    if (getStatusIds(parseInt(routeId)) == pendingStatusIds) {
      EnquiryServices.DownloadElasticEnquiryList(data).then(res => {
        if (res.status === 200) {
          if (Capacitor.isNativePlatform()) {
            const fileName = `DOFY_${MenuName}_Order${FromDate ? '_' + moment(FromDate).format('DDMMYY') : ''}${ToDate ? "_to_" + moment(ToDate).format('DDMMYY') : ''}.xls`;
            let concatedBase64 = "data:application/octet-stream;base64, " + res.data;
            downloadMobileInvoice(concatedBase64, fileName);
          } else {
            downloadCSV(res.data);
          }
          setToast(true);
          setShowLoading(false)
        }
      });
    } else {
      CommonService.post("sell", 'DownloadElasticOrdersList', data).then(res => {
        if (res.status === 200) {
          if (Capacitor.isNativePlatform()) {
            const fileName = `DOFY_${MenuName}_Order${FromDate ? '_' + moment(FromDate).format('DDMMYY') : ''}${ToDate ? "_to_" + moment(ToDate).format('DDMMYY') : ''}.xls`;
            let concatedBase64 = "data:application/octet-stream;base64, " + res.data;
            downloadMobileInvoice(concatedBase64, fileName);
          } else {
            downloadCSV(res.data);
          }
          setToast(true);
          setShowLoading(false)
        }
      });
    }
  }

  const downloadCSV = (csvData) => {
    const decodedData = atob(csvData);
    const blob = new Blob([decodedData], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `DOFY_${MenuName}_Order${FromDate ? '_' + moment(FromDate).format('DDMMYY') : ''}${ToDate ? "_to_" + moment(ToDate).format('DDMMYY') : ''}.csv`);
    document.body.appendChild(link);
    link.click();
    URL.revokeObjectURL(url);
    document.body.removeChild(link);
  };

  const resetIdHandler = (type: any) => {
    if (type === "productId") {
      // dispatch(FilterDataId({ payload: 0, type: type }));
      dispatch(updateDashboardFilter({
        sectionKey: segmentValue,
        tileKey: routeId,
        field: type,
        fieldValue: 0
      }))
    }
    if (type === "FromDate") {
      // dispatch(FilterDataId({ payload: priorDate, type: type }));
      dispatch(updateDashboardFilter({
        sectionKey: segmentValue,
        tileKey: routeId,
        field: type,
        fieldValue: priorDate
      }))
    }
    else {
      // dispatch(FilterDataId({ payload: null, type: type }));
      dispatch(updateDashboardFilter({
        sectionKey: segmentValue,
        tileKey: routeId,
        field: type,
        fieldValue: null
      }))
    }
  }

  const resetNameHandler = (type: any) => {
    if (type === "productName") {
      // dispatch(FilterDataId({ payload: 0, type: type }));
      dispatch(updateDashboardFilter({
        sectionKey: segmentValue,
        tileKey: routeId,
        field: type,
        fieldValue: 0
      }))
    }
    if (type === "FromDate") {
      // dispatch(FilterDataId({ payload: priorDate, type: type }));
      dispatch(updateDashboardFilter({
        sectionKey: segmentValue,
        tileKey: routeId,
        field: type,
        fieldValue: priorDate
      }))
    }
    else {
      // dispatch(FilterDataId({ payload: null, type: type }));
      dispatch(updateDashboardFilter({
        sectionKey: segmentValue,
        tileKey: routeId,
        field: type,
        fieldValue: null
      }))
    }
  }

  useEffect(() => {
    holdFilterhandler();
    GetLocation("country-section");
    GetHome(getLocalStorage()?.Token, "login");
    isValidUserAuthenticateForSeo(getDecodedAccessToken(getLocalStorage().Token));
    // GetDashboardStats(isToday)

    const AssigneeListData = () => {
      CommonService.postWithSingleParam('personModel', 'GetAssigneeList', "0").then(res => {
        if (res.status === 200) {
          setAssigneeList(res.data)
        }
      }).catch(e => {
      if (e == 'Request failed with status code 401') {
      navigate('/logout')
    } else {
      console.error("API error:", e);
    }
    setShowLoading(false);
    })
    }
    AssigneeListData();
  }, [productId, brandId, modelId, isToday, debouncedSearch]);

  useEffect(() => {
    const getUtmLinkd = () => {
      CommonService.get('master', 'GetUtmLinks').then(res => {
        if (res.status === 200) {
          setUtmLinks(res.data);
        }
      }).catch(e => {
      if (e == 'Request failed with status code 401') {
      navigate('/logout')
    } else {
      console.error("API error:", e);
    }
    setShowLoading(false);
    })
    }

    getUtmLinkd();
  }, []);

  const holdFilterhandler = () => {
    // Create a unique key based on DashboardName
    let storedData = JSON.parse(localStorage.getItem("localStorageKey") as any);
    if (storedData) {
      // Here, you can use the storedData object to retrieve filtered data
      const {
        productId,
        brandId,
        modelId,
        cityId,
        riderId,
        PromoCode,
        FromDate,
        ToDate,
        CompletedStartDate,
        CompletedEndDate
        // Add other filter data variables as needed
      } = storedData;
      // Now you can use this filtered data to fetch orders or perform other actions
    }
  }

  useEffect(() => {
    getOrders(parseInt(routeId), FromDate, ToDate);
    const filterData = {
      productId,
      brandId,
      modelId,
      cityId,
      riderId,
      PromoCode,
      FromDate,
      ToDate,
      // Add other filter data variables as needed
    };
    const localStorageKey = `filterData_${DashboardName}`;
    localStorage.setItem(localStorageKey, JSON.stringify(filterData));

  }, [routeId, productId, brandId, modelId, cityId, PromoCode, PersonId, riderId, FromDate, ToDate, offsetStart, rowsPerPage, debouncedSearch]);

  const unsecuredCopyToClipboard = (text: any) => {
    const textArea = document.createElement("textarea");
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    try {
      document.execCommand('copy');
      setIsOpen(true);
      setTimeout(() => { setIsOpen(false) }, 1000);
    } catch (err) {
      console.error('Unable to copy to clipboard', err);
    }
    document.body.removeChild(textArea);
  }

  const copyHandler = (content, id, event) => {
    event.stopPropagation();
    if (window.isSecureContext && navigator.clipboard) {
      navigator.clipboard.writeText(content);
      setCopiedItems(prevState => ({
        ...prevState,
        [id]: true,
      }));
      setTimeout(() => {
        setCopiedItems(prevState => ({
          ...prevState,
          [id]: false,
        }));
      }, 1000);
    } else {
      unsecuredCopyToClipboard(content);
      setCopiedItems(prevState => ({
        ...prevState,
        [id]: true,
      }));
      setTimeout(() => {
        setCopiedItems(prevState => ({
          ...prevState,
          [id]: false,
        }));
      }, 1000);
    }
  };

  useEffect(() => {
    const fetchCdnUrl = async () => {
      const url = await loadConfigforImageApiUrl();
      setCdnUrl(url);
    };
    fetchCdnUrl();
    loadConfig()
  }, []);
const loadConfig = async () => {
    const response = await fetch("/config.json");
    const config = await response.json();
    setMaxExcelExportDays(config.Max_Excel_Export_Days);
};

  return (
    <React.Fragment>
      {toast ? <CustomToaster message={Capacitor.isNativePlatform() ? 'Excel Downloaded in Document' : "Excel Downloaded Successfully"} color={'text-success'} toast={toast} setToast={setToast} /> : null}
      <div className="page-content">
        <Container fluid>
          <div className='d-flex'>
            <div>
              <h5 className="d-flex m-0 fw-semibold text-dofy dofy-admin-font-md" style={{ whiteSpace: "nowrap" }}>{MenuName.toUpperCase()} ORDERS</h5>
            </div>

          </div>
          <div className='selected-badge-filter'>
            {FromDate &&
              <Badge className='p-1'>From Date : {moment(FromDate).format("DD-MMM-YYYY")}
                {moment(FromDate).format("DD-MMM-YYYY") != moment(priorDate).format("DD-MMM-YYYY") &&
                  <i className='fa fa-times' onClick={() => { resetIdHandler("FromDate") }}></i>}</Badge>
            }
            {ToDate &&
              <Badge>To Date : {moment(ToDate).format("DD-MMM-YYYY")} <i className='fa fa-times' onClick={() => { resetIdHandler("ToDate") }}></i></Badge>
            }
            {productName &&
              <Badge>Product : {productName} <i className='fa fa-times' onClick={() => { resetIdHandler("productId"); resetNameHandler("productName") }}></i></Badge>
            }
            {brandName &&
              <Badge>Brand : {brandName} <i className='fa fa-times' onClick={() => { resetIdHandler("BrandId"); resetNameHandler("BrandName") }}></i></Badge>
            }
            {modelName &&
              <Badge>Model : {modelName} <i className='fa fa-times' onClick={() => { resetIdHandler("ModelId"); resetNameHandler("ModalName") }}></i></Badge>
            }
            {cityName &&
              <Badge>City : {cityName} <i className='fa fa-times' onClick={() => { resetIdHandler("CityId"); resetNameHandler("CityName") }}></i></Badge>
            }
            {RiderName &&
              <Badge>Rider : {RiderName} <i className='fa fa-times' onClick={() => { resetIdHandler("RiderId"); resetNameHandler("RiderName") }}></i></Badge>
            }
            {promoCodeName &&
              <Badge>PromoCode : {promoCodeName} <i className='fa fa-times' onClick={() => { resetIdHandler("PromoCode"); resetNameHandler("PromoCodeName") }}></i></Badge>
            }
          </div>
          <Row>
            <Col xl={6} lg={6} md={6} sm={12} xs={12}>
              <div className="search-box mb-2 me-2">
                <div className="position-relative">
                  <input
                    type="search"
                    name='search'
                    className="form-control bg-light border-light rounded"
                    placeholder="Search Order..."
                    value={searchValue}
                    onChange={handleSearchChange}
                  />
                  <i className="bx bx-search-alt search-icon"></i>
                </div>
              </div>
            </Col>
            <Col xl={6} lg={6} md={6} sm={12} xs={12}>
              <div className='d-flex justify-content-end align-items-middle'>
                <i className='mdi mdi-filter-menu-outline font-size-24 cursor-pointer me-3 text-primary' onClick={() => filterOpen()}></i>
    <span id="TooltipTop" style={{ cursor: 'pointer' }}>
      <i
        className={`mdi mdi-microsoft-excel font-size-24 me-2 ${isExportDisabled ? 'text-secondary' : 'text-success'}`}
        onClick={() => {
          if (!isExportDisabled) {
            downloadInvoice();
          }
        }}
      ></i>
    </span>

    <Tooltip
      placement='top'
      isOpen={ttop}
      target="TooltipTop"
      toggle={() => setttop(!ttop)}
      className='text-light'
    >
      {tooltipMessage}
    </Tooltip>

              </div>
            </Col>
          </Row>
          <CustomLoader isOpen={showLoading} />
          {filerModal &&
            <Card style={{ position: "relative", zIndex: 99 }}>
              <CardBody className='p-0'>
                <Row className='mb-1'>
                  <Col xl={10} lg={10} md={10} sm={10} xs={10} >
                    <div className=''>
                      <i className='bx bxs-filter-alt text-dofy me-2 font-size-15 '></i>
                      <span className='font-size-16 text-dofy'>Order Filters By</span>
                    </div>
                  </Col>
                  <Col className='text-end' xl={2} lg={2} md={2} sm={2} xs={2}>
                    <i className='bx bx-x font-size-18 cursor-pointer' onClick={() => setFilterModal(false)}></i>
                  </Col>
                </Row>
                <Filter onClickSell={undefined} onClickRepair={undefined} filterOpen={filterOpen} dashboardStatId={routeId} />
              </CardBody>
            </Card>
          }
          <div className='d-flex justify-content-end align-items-middle'>   {recordsCount <= rowsPerPage ? (
            <Col xl={8} lg={8} md={8} sm={12} xs={12} className='d-flex justify-content-end align-items-center'>
              <div>
                <span className="fw-semibold text-dofy">{recordsCount}</span> {"Orders"}
              </div>
            </Col>
          ) : (
            <Col xl={4} lg={4} md={4} sm={12} xs={12} className='d-flex justify-content-end align-items-center'>
              {(offsetStart + rowsPerPage) >= recordsCount ?
                <div> <span className="fw-semibold text-dofy" >{offsetStart + 1}</span> - <span className="fw-semibold text-dofy">{recordsCount}</span> of <span className="fw-semibold text-dofy">{recordsCount}</span> {"Orders"}</div>
                :
                <div><span className="fw-semibold text-dofy" >{offsetStart + 1}</span> - <span className="fw-semibold text-dofy">{offsetStart + rowsPerPage}</span> of <span className="fw-semibold text-dofy">{recordsCount}</span> {"Orders"}</div>
              }
            </Col>)}</div>

          {GetAllOrdersData.length === 0 && FilterData.length === 0 && recordsCount === 0 ?
            <Row>
              <Col xl={12} className='text-center'>
                <Card>
                  <CardBody >
                    <img src={emptyBox} alt="" />
                    <h4 className='m-2 text-dofy fw-semibold '>No Orders Found</h4>
                  </CardBody>
                </Card>
              </Col>
            </Row>
            :
            <Row>
              {GetAllOrdersData.map((item, idx) => (
                <Col xxl={12} xl={12} lg={12} md={6} sm={12} xs={12} key={idx} style={{ marginBottom: '-16px' }}>
                  <Card style={{ borderRadius: '5px', borderLeft: item.IsScheduleByTelecaller ? "3px solid #f1b44c" : "unset" }} className='cursor-pointer p-0'>
                    <CardBody className='p-1'>
                      {isMobile() ?
                        <Row>
                          {item.UTMReference && <Col>
                            <div className="alert-btndash-sm px-3 status-badge-mobile" style={{
                              background: item.UTMThemeColor
                            }}>
                              <p className='m-0 fw-bold font-size-10'>
                                {item.UTMReference}
                              </p>
                            </div>
                          </Col>}
                          <Col className='me-3'>
                            <div className="alert-btndash px-3 status-badge-mobile" style={{
                              backgroundColor: GetStatusBadge(item.StatusName)
                            }}>
                              <p className='m-0 fw-bold font-size-10'>
                                {(item.StatusName).toUpperCase()}
                              </p>
                            </div>
                          </Col>
                        </Row>
                        : null
                      }

                      <Row className='p-0'>
                        <Col xxl={3} xl={3} lg={3} md={12} sm={12} xs={12} style={{ position: 'relative' }} onClick={() => getOrderSummary(item.Id, item.IsCategoryChanged)}>
                          <div className='mt-2 align-middle p-2'>
                            <div className='d-flex align-self-center py-0'>
                              <>
                                <img src={`${cdnUrl}devicetypes/${item.ProductTypeEnumName}.png`} alt="" className='w-25 mx-1' style={{ width: "25%" }} />
                                <div className={isMobile() ? "mt-3" : ""}>
                                  <div className='mb-0'>
                                    <p className='m-0 fw-semibold dofy-admin-font-sm'>{item.BrandMasterName}</p>
                                    <p className='m-0 fw-semibold dofy-admin-font-sm text-wrap'>{item.SeriesModelName}</p>
                                    <p className='m-0 dofy-admin-font-sm'>{item.ModelVariantName}</p>
                                    {item.IMEI && <p className='m-0 text-secondary dofy-admin-font-sm'>{item.ProductTypeName == "Phone" ? "IMEI:" : "S.No"}&nbsp;{item.IMEI}</p>}

                                  </div>

                                </div>
                              </>
                            </div>
                          </div>
                        </Col>

                        <Col xl={2} lg={2} md={12} sm={12} xs={12} onClick={() => getOrderSummary(item.Id, item.IsCategoryChanged)}>
                          <div className={`${isMobile() ? " mx-4" : "text-start mt-2"} `}>
                            <div className='py-1'>
                              <Link className='' to={'#'}>
                                <p className='m-0 fw-bold text-nowrap'>{item.OrderCode}</p>
                              </Link>
                              {item.ReferralCode ?
                                <Badge color="warning" className="me-1 badge-soft-warning dofy-admin-font-md font-size-11">
                                  Referral Code: {item.ReferralCode}
                                </Badge>
                                : null
                              }
                              <Badge color="success" className="me-1 badge-soft-success dofy-admin-font-md">
                                {item.ServiceType?.replace('a device', '')}
                              </Badge>
                              <Badge color="primary" className="me-1 badge-soft-primary dofy-admin-font-md">
                                {item.ProductTypeName}
                              </Badge>
                              <p className='my-1 text-dofy fw-bold font-size-16  text-nowrap'>{<>{currencyByCountry(item.TotalAmount)}</>}/-</p>
                            </div>
                          </div>
                        </Col>

                        <Col xl={3} lg={3} md={12} sm={12} xs={12} onClick={() => getOrderSummary(item.Id, item.IsCategoryChanged)}>
                          <div className={`${isMobile() ? " mx-4" : "text-start mt-2"} `}>
                            <div className='py-1'>
                              <Row>
                                <span className='fw-semibold text-dofy'> {item.UserName}</span>
                                <div>
                                  <span className=''> {getCountryCodeStorage() == "in" ? "+91" : "+971"} {item.UserMobile}</span>
                                  <i className='bx bxs-copy-alt font-size-15 cursor-pointer mx-2' style={{ color: '#a6b2a9' }} onClick={(event) => copyHandler(item.UserMobile, item.Id, event)}></i>
                                  {copiedItems[item.Id] && <Badge color='success' className='px-2 font-size-12'>Copied</Badge>}
                                </div>
                                <div>
                                  {getCountryCodeStorage() == "in" ?
                                    <span className='font-size-12 text-muted'> {item.AppointmentPincode && <> {item.AppointmentCity}-{item.AppointmentPincode},<br /></>}</span>
                                    : <span className='font-size-12 text-muted'> {item.AppointmentPincode && <> {item.AppointmentState} - {item.AppointmentCity},<br /></>}</span>}
                                  {/* <span className='font-size-12 text-muted'> {item.CityName && <> {item.CityName}</>}</span> */}
                                </div>
                                {parseInt(routeId) === HelperConstant.dashboardNameIndex.PendingOrders ?
                                  <Row>
                                    {getCountryCodeStorage() == "in" ?
                                      <span className='font-size-12'>
                                        {item?.CityName} - {item?.DofyGeoCode}
                                        <p>{item?.DofyGeoState}</p>
                                      </span>
                                      : <span className='font-size-12'>
                                        {item?.DofyGeoState} - {item?.DofyGeoCode}
                                      </span>}

                                  </Row>
                                  :
                                  <p className='m-0 font-size-12'>
                                    {moment(item.AppointmentDate).format("DD-MMM-YYYY")} &nbsp; {moment(item.StartTime).format('LT')} - {moment(item.EndTime).format('LT')}
                                  </p>
                                }
                              </Row>
                            </div>
                          </div>
                        </Col>
                        <Col xl={4} lg={4} md={12} sm={12} xs={12} >
                          {!isMobile() ? <Row>
                            <Col>
                              <div className="alert-btndash px-3" style={{
                                backgroundColor: GetStatusBadge(item.StatusName)
                              }}>
                                <p className='m-0 fw-bold font-size-10'>
                                  {(item.StatusName).toUpperCase()}
                                </p>
                              </div>
                            </Col>
                          </Row> : null}

                          <div className={`${isMobile() ? " mx-4" : ""} `}>
                            {(item.StatusId === HelperConstant.StatusId.COMPLETED) && item.CompletedDate ?
                              <div>
                                <i className='bx bxs-check-circle text-success font-size-13 me-1 align-middle'></i>
                                <span className='m-0 font-size-13 text-success fw-semibold'>{moment(item.CompletedDate).format("DD-MMM-YYYY, HH:mm a")}</span> &nbsp;&nbsp;
                              </div>
                              :
                              <>
                              </>
                            }
                            {item.StatusId === HelperConstant.StatusId.CANCEL_REQUEST ? (
                              <>
                                <i className='bx bxs-info-circle text-danger me-1 align-middle font-size-13'></i>
                                <span className='font-size-12 text-danger'>{moment(item.Modified).format("DD-MMM-YYYY")}</span> &nbsp;&nbsp;
                              </>
                            ) : ((item.StatusId === HelperConstant.StatusId.FAILED || item.StatusId === HelperConstant.StatusId.CANCELLED || item.StatusId === HelperConstant.StatusId.RETURN) && (
                              <>
                                <i className='bx bxs-info-circle text-danger me-1 align-middle font-size-13'></i>
                                <span className='font-size-12 text-danger'>{moment(item.Modified).format("DD-MMM-YYYY")}</span> &nbsp;&nbsp;
                              </>
                            ))}
                            {item.ModifiedUser ?
                              <div>
                                <i className='bx bxs-edit text-info me-1 align-middle font-size-13'></i>
                                <span className='text-primary fw-semibold'>{item.ModifiedUser ? `${item.ModifiedUser}` : ""} </span> &nbsp;&nbsp;
                              </div>
                              :
                              <>
                              </>
                            }
                            {item?.AssigneeId <= 0 && (item?.StatusId !== HelperConstant.StatusId.FAILED && item?.StatusId !== HelperConstant.StatusId.CANCEL_REQUEST && item?.StatusId !== HelperConstant.StatusId.CANCELLED && item?.StatusId !== HelperConstant.StatusId.PENDING) ?
                              <div className=''>
                                <CustomButton type={'button'} btnClassName={`assign-btn ${isMobile() ? "btn-md" : "btn-sm "} btn-light dofy-admin-font-md mx-2 my-2 fw-semibold`} iconClasssName={undefined} name={'Assign Now'} onClick={() => { setOrderId(aes_encryption(item.Id)); setmodal_center(true); setTechnicianAssignId(0); }} />
                              </div>
                              :
                              <>
                                {item.AssigneeName === null && item.AliasName === null ? "" :
                                  <div className='text-center pb-2'>
                                    <div style={{ textAlign: "left" }}>
                                      <span className='text-primary fw-semibold'> {(item.AliasName != null && item.AliasName.length > 0) ? `${item.AssigneeName} - ${item.AliasName}` : item.AssigneeName} </span>
                                    </div>
                                  </div>
                                }
                              </>
                            }
                            {!isMobile() && item.UTMReference ?
                              <div className="alert-btndash-UTM px-3" style={{
                                background: "linear-gradient(-120deg, #4285f4, #34a853, #fbbc05, #ea4335)"
                              }}>
                                <p className='m-0 fw-bold font-size-10'>
                                  {(item.UTMReference)}
                                </p>
                              </div>
                              : null}
                          </div>

                        </Col>
                      </Row>

                    </CardBody>
                  </Card>
                </Col>
              ))}
              {<Paginate recordsCount={recordsCount} rowName={'Orders'} rowsPerPage={rowsPerPage} currentPage={currentPage} setCurrentPage={setCurrentPage} offsetStart={offsetStart} setOffsetStart={setOffsetStart} />}
            </Row>
          }
          <AssigneeModal aliasname={undefined} setModelOpen={setmodal_center} modalOpen={modal_center} getTechnicianAssigneeId={TechnicianAssigneeData} assigneeList={AssigneeList} isAssigned={isAssignBtnClicked} />
        </Container>
      </div>
    </React.Fragment >

  );
}

export default Dashboard;